import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function SignalWifiStatusbarConnectedNoInternet4Icon(props: IconProps) {
    return <Icon {...props} iconKey={"signal_wifi_statusbar_connected_no_internet_4"}/>
}
